/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = {
	pre:"XSEED_",
	// defaultExpiration:99999	//天数
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var config = __webpack_require__(0)

var helper = {
	getUrlKey:function(url){
		var index1=url.lastIndexOf("\/")+1;
		var index2=url.lastIndexOf(".");  
		
		var tag = url.substring(index1,index2);
		return tag
	}
}

module.exports = helper

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helper = __webpack_require__(1)
var lcache = __webpack_require__(3)
var net = __webpack_require__(4)
var config = __webpack_require__(0)

var xseed = {
	version:"0.01",
	/**
	 * 这个函数是给待缓存的js文件调用的，由于跨域原因，不能用ajax获取js文件，只能让目标js文件调用方法来存储自己
	 * 使用方法如下
	 * xseed.cacheAndExecute(function(){
	 * 		xxxxxx目标文件代码
	 * })
	 * @param  {[type]} func [description]
	 * @return {[type]}      [description]
	 */
	store:function(key,func){
		var funcString = func.toString()
		var ret = lcache.save(config.pre+key,funcString)
		this.execCode(funcString)
		console.log(ret)
	},
	launch:function(){
		//找到自己的script标签
		var scripts = document.getElementsByTagName("script")
		var len = scripts.length
		var that = this
		for(var i=0;i<len;++i){
			var script = scripts[i]
			if(script.src && script.src.toLowerCase().indexOf("\/xseed.js")>=0){
				var url = script.dataset.source.toLowerCase()
				var runUrl = script.dataset.run
				var key = config.pre+helper.getUrlKey(url)
				var content = lcache.load(key)
				if(content){
					this.execCode(content,function(){
						console.log("inject cache script complete")
						that.loadRunScript(runUrl)
					})	
				}else{
					net.loadResource(url,function(){
						console.log("source loadcompleted: "+url)
						setTimeout(function(){
							that.loadRunScript(runUrl)
						},10)
					})
				}
				break
			}
		}
	},

	//加载目标运行script
	loadRunScript:function(url){
		net.loadResource(url)
	},
	// 执行代码片段
	execCode:function(codeStr, callback) {
		var script = document.createElement('script');
		script.defer = false;
		// Have to use .text, since we support IE8,
		// which won't allow appending to a script
		script.text = '('+codeStr+')()';
		var head = document.head || document.getElementsByTagName('head')[0];
		head.appendChild( script );
		setTimeout(function(){
			callback&&callback()
		},0)
	}
}
window.xseed = xseed
xseed.launch()

// lcache.saveResource("//gbfek.dfcfw.com/project/gubawap/bundle/zepto_react_all_xseed.js")

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// var net = require("./net")
var config = __webpack_require__(0)
var helper = __webpack_require__(1)

var inCache = [];

var lcache = {
	addLocalStorage : function( key, content ) {
		try {
			localStorage.setItem( key, content );
			return true;
		} catch( e ) {
			console.log(e)
			return false;
			// if ( e.name.toUpperCase().indexOf('QUOTA') >= 0 ) {
			// 	var item;
			// 	var tempScripts = [];

			// 	for ( item in localStorage ) { //满了
			// 		if ( item.indexOf( storagePrefix ) === 0 ) {
			// 			tempScripts.push( JSON.parse( localStorage[ item ] ) );
			// 		}
			// 	}

			// 	if ( tempScripts.length ) {
			// 		// tempScripts.sort(function( a, b ) {
			// 		// 	return a.stamp - b.stamp;
			// 		// });

			// 		basket.remove( tempScripts[ 0 ].key );

			// 		return addLocalStorage( key, storeObj );

			// 	} else {
			// 		// no files to remove. Larger than available quota
			// 		return;
			// 	}

			// } else {
			// 	// some other error
			// 	return;
			// }
		}

	},
	getLocalStorage:function(key){
		try{
			var ret = localStorage.getItem( key );
			return ret
		}catch(e){
			console.log(e)
			return null
		}
		
	},
	save:function(key,content){
		// var now = +new Date();
		var ret=this.addLocalStorage(key,content)
		return ret

		// var dom = net.loadResource(url,function(newDom){
		// 	console.log(newDom)
		// })
		// var tag = getUrlTag(url)
		// dom.setAttribute("id",tag)
		// net.ajax({
		// 	url:url
		// })
	},
	load:function(key){
		var ret = this.getLocalStorage( key )
		return ret
	}
}

module.exports = lcache

/***/ }),
/* 4 */
/***/ (function(module, exports) {

//XMLHttpRequest简单封装
// function ajax(json){
// 	var json = json||{};
// 	var type = json.type||"GET";
// 	type = type.toUpperCase();
// 	var url = json.url;
// 	var async = json.async||true;
// 	var data = json.data||"";
// 	var dataArr = [];
// 	for(var key in data){
// 		dataArr.push(key+"="+data[key]);
// 	}
// 	var dataStr = "";
// 	if(dataArr.length>0){
// 		dataStr = dataArr.join("&");
// 	}
// 	var simplePromise = {
// 		successCall:null,
// 		success:function(cb){
// 			simplePromise.successCall=cb;
// 			return simplePromise;
// 		},
// 		errorCall:null,
// 		error:function(cb){
// 			simplePromise.errorCall=cb;
// 			return simplePromise;
// 		},
// 		request:null
// 	};

// 	var request;
// 	try{
// 		request = new XMLHttpRequest();
// 	}catch(e){//兼容todo

// 	}

// 	if(request){
// 		if(type=="GET"){
// 			request.open(type,url+"?"+dataStr,async);
// 			request.withCredentials = true;
// 			request.send(null);
// 		}else{
// 			request.open(type,url+"?mt="+Math.random(),async);
// 			request.withCredentials = true;
// 			request.send(dataStr);
// 		}

// 		request.onreadystatechange=function(){
// 			if(request.readyState==4){
// 				if(request.status==200){
// 					var res = request.responseText;
// 					if(simplePromise.successCall){
// 						simplePromise.successCall(res);
// 					}
// 				}else{
// 					if(simplePromise.errorCall){
// 						simplePromise.errorCall(request)
// 					}
// 				}

// 			}
// 		}
// 	}
// 	simplePromise.request=request;
// 	return simplePromise;
// }

function loadResource(url,cb){
	var index1=url.lastIndexOf(".")+1;  
	var index2=url.length;
	var type = url.substring(index1,index2);
	var newDom = null;
	if(type=="js"){
		newDom = document.createElement("script")
		newDom.setAttribute("type","text/javascript")
		newDom.setAttribute("src", url)
		document.getElementsByTagName("body")[0].appendChild(newDom);
        if (document.all) { //IE
            newDom.onreadystatechange = function() {
                if (newDom.readyState == 'loaded' || newDom.readyState == 'complete') {
                    cb&&cb(newDom)
                }
            }
        } else {
            newDom.onload = function() {
                cb&&cb(newDom)
            }
        }

	}else if(type=="css"){
		newDom = document.createElement("link")
		newDom.setAttribute("rel","stylesheet")
		newDom.setAttribute("type","text/css")
		newDom.setAttribute("href",url)
		document.getElementsByTagName("head")[0].appendChild(newDom)
		cb&&cb()
	}
	return newDom
}

var net = {
	// ajax:ajax,
	loadResource:loadResource
}

module.exports = net;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// xseed.js